import React, { Component } from 'react'
import { Form } from 'react-bootstrap'

const KedoMonacoEditor = React.lazy(() =>
    import('../../Editors/KedoMonacoEditor')
)

class DefDossierDefFieldCalcSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formula: this.props.item?.settings?.formula ?? '',
        }
    }

    render() {
        return (
            <div>
                <h5>{this.props.kedo.t('Additional settings')}</h5>
                <Form.Group controlId="formula">
                    <Form.Label>{this.props.kedo.t('Formula')}</Form.Label>
                    <KedoMonacoEditor
                        kedo={this.props.kedo}
                        language={'kedoexpr'}
                        originEntity={this.props.defDossier}
                        value={this.state.formula}
                        onChange={(value) => {
                            this.setState({ formula: value })
                            setTimeout(
                                () => this.props.onChange('formula', value),
                                50
                            )
                        }}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>Formula</Form.Label>
                    <Form.Control
                        value={this.state.formula}
                        name={'formula'}
                        onChange={(e) => {
                            this.setState({ formula: e.target.value })
                            setTimeout(
                                () =>
                                    this.props.onChange(
                                        'formula',
                                        e.target.value
                                    ),
                                50
                            )
                        }}
                        as="textarea"
                        rows={3}
                    />
                </Form.Group>
            </div>
        )
    }
}

export default DefDossierDefFieldCalcSettings
